import { TextDisplayCell } from "../../../common/components/DataGrid";
import {
  generateLoSetpointCell,
  generateLoLoSetpointCell,
  generateHiSetpointCell,
  generateHiHiSetpointCell,
} from "../../helpers/CellGenerators";

export const LoSetpointCell = ({ row, lookupValues }) => {
  return <TextDisplayCell value={generateLoSetpointCell(row, lookupValues)} />;
};

export const LoLoSetpointCell = ({ row, lookupValues }) => {
  return (
    <TextDisplayCell value={generateLoLoSetpointCell(row, lookupValues)} />
  );
};

export const HiSetpointCell = ({ row, lookupValues }) => {
  return <TextDisplayCell value={generateHiSetpointCell(row, lookupValues)} />;
};

export const HiHiSetpointCell = ({ row, lookupValues }) => {
  return (
    <TextDisplayCell value={generateHiHiSetpointCell(row, lookupValues)} />
  );
};
